import * as React from 'react'
import { MessageBlock, MessageTypes, Text } from 'DVWebNodeUI'
import { PangaeaBannerProps } from '../index'
import { RequestContext, WPSClient } from '@utils'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { stringifyOnClient } from '../utils/utils'
import * as st from './banner.module.scss'
import { PType } from '../../DVWebNodeDetail/integrations/aui'

const dismissHandler = async (context: RequestContext, csrfToken: string) => {
  const wpsClient = new WPSClient()

  await wpsClient.SetPreferences({
    context,
    csrfToken,
    sessionBased: stringifyOnClient({
      pangaeaBannerOptOut: true
    }) as WpsRuntime.atv.wps.SetSessionBasedPreferencesInput
  })
}

declare let window: Window & { P: PType }

export class Banner extends React.Component<PangaeaBannerProps> {
  link: HTMLAnchorElement
  mash: any

  constructor(props: PangaeaBannerProps) {
    super(props)
    this.link = undefined
  }

  openLinkInExternalBrowser(e: Event, href?: string): void {
    if (this.mash && href) {
      e.preventDefault()
      this.mash.openInExternalBrowser({
        url: href
      })
    }
  }

  findLink() {
    const banner = document.getElementById('av-pangaea-banner')
    const links = banner && banner.getElementsByTagName("a")
    return links && links[0] as HTMLAnchorElement
  }

  updateLinkClickHandler = (e: MouseEvent) => {
    this.link && this.openLinkInExternalBrowser(e, this.link.href)
  }

  componentDidMount() {
    const link = this.findLink()
    link && link.addEventListener('click', this.updateLinkClickHandler)
    this.link = link

    if (typeof window !== 'undefined' && typeof window.P !== 'undefined') {
      window.P.when('mash').execute((mashObj: any) => {
        this.mash = mashObj
      })
    }
  }

  componentWillUnmount() {
    const link = this.link
    link && link.removeEventListener('click', this.updateLinkClickHandler)
  }

  render() {
    const props = this.props
    return !props.banner ? null :
      <div className={st.avuStickyTopSection} id="av-pangaea-banner">
        <MessageBlock heading={undefined} type={MessageTypes.info} dismissable={true}
                      onDismiss={() => { dismissHandler(props.context, props.csrfToken) }}>
          <Text string={props.banner}/>
        </MessageBlock>
      </div>
  }
}
